// Contrato spec-002 §4.1 (ui-components.md) — shapes/defaults idênticos p/ sucesso e falha.
export default {
  catalog: [],
  catalogLoading: false,
  instances: [],
  instancesLoading: false,
  // body.status === 403 em catálogo/instances (flag-mestra OFF) — tela "módulo não
  // contratado" (RF8.6).
  moduleForbidden: false,

  // spec-003 (Conversar) — slice `chat` (contrato ui-components §4.1). Todas as
  // propriedades declaradas aqui p/ reatividade Vue 2 (sem $set posterior).
  chat: {
    agents: [], // AgentDisponivelItem[] (api.yaml) — seletor do chat
    selectedAgentId: null, // id_instance selecionado
    conversations: [], // conversas da instância selecionada (context AI_FRAMEWORK)
    selectedConversationId: null, // uuid
    messages: [], // histórico + turnos anteriores (bolhas materializadas)
    streaming: false, // input desabilitado durante o stream
    responseTokens: [], // tokens incrementais do assistant (array — chat-message.join(''))
    thinkingSteps: [], // passos de raciocínio do turno corrente
    activeToolCalls: [], // nomes de tools em execução — sem consumidor de tela hoje
    pendingProposals: [], // [{operacao, entidade, resumo}] — write tools em preview (RF6.3)
    currentRunId: null, // id_run do evento start (correlação — nunca exibido cru no MVP)
    systemMessages: [], // gates inline (G9) — {status, message}
    moduleForbidden: false, // 403 flag-mestra OFF no seletor (RF8.6)
    loadingAgents: false,
    loadingConversations: false,
    loadingMessages: false,
  },
}
